import React from 'react'

function Header() {
  return (
    <div className='header c-bg '>
      <div className='container'>
        <h1>Bill Gate's Money</h1>
      </div>
    </div>
  )
}

export default Header